/** Imported slide titles often contain the diagnosis or instrument name that
 * the learner is being asked to identify, so learner views use neutral labels. */
export function learnerStationLabel(stationId: string, fallbackOrder?: number): string {
  const match = /(?:^|[-_])(\d+)$/.exec(stationId.trim())
  const number = match ? Number.parseInt(match[1], 10) : fallbackOrder
  return Number.isFinite(number) && Number(number) > 0 ? `المحطة ${Number(number)}` : 'محطة عملية'
}
